import { Carousel } from '@mantine/carousel';
import { Box } from '@mantine/core';
import Autoplay from 'embla-carousel-autoplay';
import { type PropsWithChildren, useRef } from 'react';
import classes from './BannerLayout.module.css';
export const BannerLayout: React.FC<PropsWithChildren> = ({
  children
}) => {
  const autoplay = useRef(Autoplay({
    delay: 4000,
    stopOnMouseEnter: true,
    stopOnInteraction: false
  }));
  return <Box pb={40}>
      <Carousel loop withIndicators slideGap="sm" withControls={false} classNames={classes} plugins={[autoplay.current]}>
        {children}
      </Carousel>
    </Box>;
};